export enum LogFileType {
    SERIAL_PORT = "SerialLog",
    SERIAL_PORT_1 = "SerialLog1",
    SERIAL_PORT_2 = "SerialLog2",
    PDN_PACKET = "CaptureLog",
};